import { useMutation } from '@tanstack/react-query';

import { ApiError } from '@/lib/api/api-error';
import { getApiErrorMessage } from '@/lib/api/client';
import { postEnvelope } from '@/lib/api/client-v2';
import { notify } from '@/lib/notify';
import { useUiStore } from '@/stores/ui-store';
import { ENDPOINTS } from '@/types/api/endpoints';

/**
 * Message de la v1 pour un `abort(404)` nu (code déjà attribué ou assuré non éligible) : la v2 le
 * rend sous son propre libellé générique, on garde celui de la v1.
 */
const MESSAGE_404_V1 = 'Ressource non trouvée.';

/**
 * Demande d'un code promo partenaire (`POST /promo-code`), ex : `I&MAPRIL` pour In&Motion.
 *
 * Reprend le middleware `customer/requestCodePromo` : le code obtenu (`message` de l'enveloppe)
 * est gardé dans `useUiStore().codePromoUser` ; un échec ouvre la popin d'erreur.
 */
export const useRequestCodePromo = () =>
    useMutation({
        mutationFn: ({ campaign }: { campaign: string }) => postEnvelope<null>(ENDPOINTS.promoCode, { campaign }),
        onSuccess: (envelope) => {
            useUiStore.getState().setCodePromoUser(envelope.message ?? '');
        },
        onError: (error) => {
            const message =
                error instanceof ApiError && error.httpStatus === 404 ? MESSAGE_404_V1 : getApiErrorMessage(error);

            void notify({
                html: '<p>Une erreur est survenue : ' + message + '</p>',
                icon: 'error',
                title: 'Attention !',
                confirmButtonText: "J'ai compris",
            });
        },
    });
